import { createRouter, createWebHashHistory } from "vue-router";
import SubmitOrder from "@/views/SubmitOrder";
import Login from "@/views/Login";
import SubMenu from "@/views/SubMenu";
import Menu from "@/views/Menu";
import Home from "@/views/Home";
import ChooseFood from "@/views/ChooseFood";
import Receipt from "@/views/Receipt";
import MyFactors from "@/views/FactorList";
import NoteList from "@/views/NoteList";
import Note from "@/views/Note";
import ManagementIndex from "@/views/Management/Index";
import NotificationInbox from "../views/NotificationInbox";
import MixedChart from "../components/Management/MixedChart";
import MixedChart2 from "../components/Management/MixedChart2";
import test from "../components/test";
import store from "../store";
import Analytics from "../views/Management/Analytics";
import Users from "../views/Management/Users";
import Monitoring from "../views/Management/Monitoring";
import AnalyticsHotel from "../views/Management/AnalyticsHotel";
import UploadBanner from "@/views/UploadBanner";
import ReportSuggest from "../views/Management/ReportSuggest";
import OptionPage from "../views/Management/OptionPage";

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/menu",
    name: "Menu",
    component: Menu,
    children: [
      {
        path: ":id",
        name: "SubMenu",
        component: SubMenu,
      },
    ],
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/submit-order",
    name: "SubmitOrder",
    component: SubmitOrder,
    meta: {
      requiresAuth: true,
      role: "Waiter",
    },
  },
  {
    path: "/submit-order/menu",
    name: "ChooseFood",
    component: Menu,
    children: [
      {
        path: ":id",
        name: "ChooseFoodMenu",
        component: ChooseFood,
      },
    ],
    meta: {
      requiresAuth: true,
      role: "Waiter",
    },
  },
  {
    path: "/submit-order/receipt",
    name: "Receipt",
    component: Receipt,
    meta: {
      requiresAuth: true,
      role: "Waiter",
    },
  },
  {
    path: "/my-factors",
    name: "MyFactors",
    component: MyFactors,
    meta: {
      requiresAuth: true,
      role: "Waiter",
    },
  },
  {
    path: "/note-list",
    name: "NoteList",
    component: NoteList,
    meta: {
      requiresAuth: true,
      role: "Manager",
    },
  },
  {
    path: "/note-list/:id",
    name: "Note",
    component: Note,
    meta: {
      requiresAuth: true,
      role: ["Manager", "CermonyManager"],
    },
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
  },
  {
    path: "/management",
    name: "Management",
    component: ManagementIndex,
    meta: {
      requiresAuth: true,
      role: "Hotel",
    },
  },
  {
    path: "/management/analytics",
    name: "Analytics",
    component: Analytics,
    meta: {
      requiresAuth: true,
      role: "Admin",
    },
  },
  {
    path: "/management/hotel-analytics",
    name: "AnalyticsHotel",
    component: AnalyticsHotel,
    meta: {
      requiresAuth: true,
      role: "Hotel",
    },
  },
  {
    path: "/management/users",
    name: "Users",
    component: Users,
    meta: {
      requiresAuth: true,
      role: "Admin",
    },
  },
  {
    path: "/management/OptionPage",
    name: "OptionPage",
    component: OptionPage,
    meta: {
      requiresAuth: true,
      role: "Admin",
    },
  },
  {
    path: "/management/chart/:type",
    name: "ManagementChart",
    component: MixedChart,
    meta: {
      requiresAuth: true,
      role: "Admin",
    },
  },
  {
    path: "/management/chart2/:type",
    name: "ManagementChart2",
    component: test,
    meta: {
      requiresAuth: true,
      role: "Admin",
    },
  },
  {
    path: "/management/chart2/:type",
    name: "ManagementChart2",
    component: MixedChart2,
    meta: {
      requiresAuth: true,
      role: "Admin",
    },
  },
  {
    path: "/management/ReportSuggest",
    name: "ReportSuggest",
    component: ReportSuggest,
    meta: {
      requiresAuth: true,
      role: "Admin",
    },
  },
  {
    path: "/notification-inbox",
    name: "NotificationInbox",
    component: NotificationInbox,
    meta: {
      requiresAuth: true,
    },
  },

  {
    path: "/monitoring",
    name: "Monitoring",
    component: Monitoring,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/UploadBanner",
    name: "UploadBanner",
    component: UploadBanner,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue"),
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  let matchedRoute;
  if (
    to.matched.some((record) => {
      matchedRoute = record;
      return record.meta.requiresAuth;
    })
  ) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (localStorage.getItem("token") === null) {
      next({
        path: "/login",
      });
    } else {
      console.log(matchedRoute.meta.role);
      if (
        matchedRoute.meta.role === undefined ||
        matchedRoute.meta.role === store.state.user.role ||
        store.state.user.role === "Admin" ||
        store.state.user.role === "CermonyManager"
      ) {
        next();
      } else {
        console.log("Error");
      }
    }
  } else {
    next(); // make sure to always call next()!
  }
});
export default router;
